import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const getPatientEnrollmentInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-patient-insight`, values, token, dispatch);
};

export const getPatientPieInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-patient-pie-insight`, values, token, dispatch);
};

export const getOrgInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-org-insight`, values, token, dispatch);
};

export const getApplicationInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-appln-insight`, values, token, dispatch);
};

export const getApplicationPieInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-appln-pie-insight`, values, token, dispatch);
};

export const getUserInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-user-insight`, values, token, dispatch);
};

export const getSupportInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-support-insight`, values, token, dispatch);
};

export const getActionInsight = ({values, dispatch, token }) => {
    return ApiClient.post(`${API_URL}/insight/get-actions-insight`, values, token, dispatch);
};
